<div class="sidebar-wrapper">
  <app-sidebar-header>
    <div smallTitle>Add Contact</div>
    <div mainTitle>Input Contact Information</div>
  </app-sidebar-header>
  <div class="main-content">
    <form #form="ngForm" role="form">
      <div class="two-input-row">
        <app-floating-input
          name="email"
          [(ngModel)]="model().email"
          label="Email Address"
          placeholder="Email Address"
          type="email"
          required
        ></app-floating-input>
        <app-floating-input name="title" label="Title" placeholder="Title" required [(ngModel)]="model().title">
        </app-floating-input>
      </div>
      <div class="two-input-row">
        <app-floating-input
          name="first_name"
          [(ngModel)]="model().first_name"
          label="First Name"
          placeholder="First Name"
          required
        ></app-floating-input>
        <app-floating-input
          name="last_name"
          label="Last Name"
          placeholder="Last Name"
          required
          [(ngModel)]="model().last_name"
        >
        </app-floating-input>
      </div>
      <div class="two-input-row">
        @if (isAddCompany()) {
          <app-floating-input
            #addCompanyInput
            name="company_name"
            label="Company Name"
            placeholder="Company Name"
            required
            [(ngModel)]="companyName"
          >
          </app-floating-input>
        } @else {
          <app-dropdown
            name="group_id"
            label="Company Name"
            placeholder="Company Name"
            [required]="true"
            [(ngModel)]="model().group_id"
            [options]="contactGroupOptions()"
            (firstExtraOptionSelected)="switchToAddCompany()"
          >
            <ng-template #firstExtraOption>
              <div class="text-blue-700 flex gap-2 items-center">
                <span class="icon-add-round text-size_xl"></span>
                <span class="">Add New Company</span>
              </div>
            </ng-template>
          </app-dropdown>
        }
        <app-floating-input
          name="phone"
          type="tel"
          label="Phone Number"
          placeholder="Phone Number"
          [(ngModel)]="model().phone"
        >
        </app-floating-input>
      </div>
      <div class="two-input-row">
        <app-floating-input
          name="address"
          label="Address"
          placeholder="Address"
          [(ngModel)]="model().address"
        ></app-floating-input>
        <app-floating-input name="city" label="City" placeholder="City" [(ngModel)]="model().city">
        </app-floating-input>
      </div>
      <div class="two-input-row">
        <app-dropdown
          name="state"
          label="State"
          placeholder="State"
          [(ngModel)]="model().state"
          [options]="states()"
        ></app-dropdown>
        <app-floating-input name="zip" label="ZIP Code" placeholder="ZIP Code" [(ngModel)]="model().zip">
        </app-floating-input>
      </div>
    </form>
  </div>

  <div class="buttons flex justify-end">
    <app-simple-button (click)="save()" buttonStyle="color_accent_filled">Save</app-simple-button>
  </div>
</div>
